import { Box, SxProps, Theme, Typography } from "@mui/material";
import { Font } from "./types";

type InternFontProps = {
  font: Font;
  size?: "small" | "large";
};

const InternFont = ({ font, size = "small" }: InternFontProps) => {
  const typographySx: SxProps<Theme> = {
    fontFamily: font.name,
    fontSize: size === "large" ? "14px" : "10px",
    textAlign: "center",
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "break-spaces",
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
        borderRadius: "4px",
        p: 1,
        border: "1px solid #E0E0E0",
        width: "100%",
        minHeight: size === "large" ? "40px" : "30px",
      }}
    >
      <Typography variant="caption" sx={typographySx} fontWeight="bold">
        {font.name}
      </Typography>
      <Typography variant="caption" sx={typographySx}>
        {font.name}
      </Typography>
    </Box>
  );
};

export default InternFont;
